import apis from ".";

export async function getHomeCategories(token) {
    try {
      const result = await apis.get(
        `/category/get-all-categories?page=1&perPage=100`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return result;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
}
  